<script>

import Utils from '../../common/Utils';
import CommonConstants from '../../common/Constants';
import config from '../../common/genericPanelConf';
import Service from '@/services/planning';
import ResponsiveButton from '../../components/generic/ResponsiveButton.vue'
import GenericDataTable from '../../components/generic/GenericDataTable.vue'
import GenericCustomAutocompleteV2 from '../../components/generic/GenericCustomAutocompleteV2.vue'

export default {
    components: 
        {
            ResponsiveButton,
            GenericDataTable,
            GenericCustomAutocompleteV2
        },
    props: [],
    data() {
        return {                            
            filters: {
                monthStartDate: Utils.setFirstDayOfMonth(Utils.formatDatePlusMonths(new Date(), -1)),
            },

            deadstockFilter: {
                initialStockDate: Utils.setFirstDayOfMonth(Utils.formatDatePlusMonths(new Date(), -1)),
                finalStockDate: Utils.setLastDayOfMonth(Utils.formatDatePlusMonths(new Date(), 0))
            },
            twentyFour: '24.00',
            deadstocks: [],
            showAddDialog: false,
            addItem: [],
            validationMessage: [],
            disableCalculate: false,
            hideInitialDate: false,
            showDeadstockDialog: false,
            selectedItems: []
        }
    },
    created() {       
        this.configuration = config.getConfiguration('StockAdjustment');
    },
    mounted() {       
        this.$store.dispatch('security/setNavbarTitle', 'StockAdjustment.page_title');
        this.loadStockAdjustment();
        this.addItem.push({});
    },
    computed: {
        constants() {
            return CommonConstants; 
        },
        utils() {
            return Utils;
        },
        uiPermissions() {
            return this.$store.getters['security/uiPermissions'];
        }
    },
    methods: {
        loadStockAdjustment(){
            this.submitted = true;
            let filters = [];
        
            filters.push({
                operator: '>=',
                value: this.filters.monthStartDate,
                property: 'Date',
            });

            this.$refs.stockAdjustment.filterFromView(filters);
            this.submitted = false;
        },
        onRowEdit(data){
            this.$store.dispatch("generic/setLoading", true);
            Service.updatePlanningStockAdjustment(data, (response) => {
                this.$store.dispatch("generic/setLoading", false);
                if (response.success) {
                    this.loadStockAdjustment();
                    this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000 });
                } else {
                    this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
            })
        },
        checkAdjustment(){
            return this.addItem[0] != null && this.addItem[0].adjustmentType != undefined && this.addItem[0].adjustmentType == 'Deadstock';
        },
        calculate(){
            this.$store.dispatch("generic/setLoading", true);
            Service.calculatePlanningStockAdjustment(this.addItem[0], response => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success && response.data != null){
                    /*this.addItem = {
                        date: response.data.date,
                        tankCode: response.data.tankCode,
                        productCode: response.data.productCode,
                        poolName: response.data.poolName,
                        adjustmentType: response.data.adjustmentType,
                        dischargeOrCharge: response.data.dischargeOrCharge,
                        description: response.data.description,
                        cubicMeters: response.data.cubicMeters,
                        density: response.data.density,
                        conversionFactor: response.data.conversionFactor,
                        barrels
                    };   */
                    this.addItem = [];

                    for(let i = 0; i < response.data.length; i++){
                        let item = response.data[i];
                        item.initialStockDate = Utils.dateToCurrentTimeZone(item.initialStockDate);
                        item.date = Utils.dateToCurrentTimeZone(item.date);
                        this.addItem.push(item);                        
                    }  

                    if(this.addItem.length == 0){
                        this.addItem.push({});
                    }

                    this.disableCalculate = true;        
                }else{
                    this.addItem = [];
                    this.addItem.push({});
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        dialogAddSave(){
            if(this.checkValidation()){
                this.$store.dispatch("generic/setLoading", true);
                for(let i = 0; i < this.addItem.length; i++){

                    Service.addPlanningStockAdjustment(this.addItem[i], response => {
                        this.$store.dispatch("generic/setLoading", false);
                        if(response.success){   
                            this.showAddDialog = false;
                            this.addItem = [];
                            this.addItem.push({})
                            this.loadStockAdjustment();                 
                            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.create_message_success'), life: 3000});
                        }else{
                            this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                        }
                    })
                }               
            }           
        },
        checkValidation(){
            this.validationMessage = [];
            
            for(let i = 0; i < this.configuration.columns.length; i++){
                let item = this.configuration.columns[i];

                for(let i = 0; i < this.addItem.length; i++){
                    if(item.validations != undefined && item.validations.required){
                        if(this.addItem[i][item.name] == null || this.addItem[i][item.name] == undefined){
                            this.validationMessage.push(item.name);
                        }                 
                    }
                }               
            }

            return this.validationMessage.length == 0;
        },
        resetForm(){
            this.addItem = [];
            this.addItem.push({});
            this.disableCalculate = false;
            this.hideInitialDate = false;
            this.validationMessage = [];
        },

        resetFormDeadstock(){
            this.deadstocks = [];
        },

        setClass(name){
            for(let i = 0; i < this.validationMessage.length; i++){
                if(this.validationMessage[i] == name){
                    return "p-invalid";
                }
            }

            return "";
        },
        getFields(){
            let fields = [];

            for(let i = 0; i < this.configuration.columns.length; i++){
                let item = this.configuration.columns[i];

                if(item != null && (item.name == "initialStockDate") || (item.name != "initialStockDate" && !item.formHide)){
                    fields.push(item);
                }
            }

            return fields;
        },
        onRowSelected(records){
            this.selectedItems = [...records];
        },
        importAdjustment(){
            this.$confirm.require({
                message: this.$t('messages.confirm_import'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {                  
                
                    this.$store.dispatch("generic/setLoading", true);
                    Service.importPlanningStockAdjustment(this.selectedItems, 
                        response => {   
                        this.$store.dispatch("generic/setLoading", false);      
                        if(response.success){
                            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.create_message_success'), life: 3000});
                            this.loadStockAdjustment();
                        }else{
                            this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                        }
                        })
                    },
                reject: () => {
                    this.$confirm.close();
                }
            });
        },
        massiveImportDeadstock(){
            this.deadstocks = [];
            this.$store.dispatch("generic/setLoading", true);
            Service.getAllDeadstocks(this.deadstockFilter, (response) => {
                this.$store.dispatch("generic/setLoading", false);
                if (response.success) {
                    for(let i = 0; i < response.data.length; i++){
                        let item = response.data[i];
                        item.initialStockDate = Utils.dateToCurrentTimeZone(item.initialStockDate);
                        item.date = Utils.dateToCurrentTimeZone(item.date);

                        item.referenceDate = this._formatDate24Hour(item.referenceDate);
                        this.deadstocks.push(item);                        
                    }  
                } else {
                    this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
            })
        },
        saveMassiveDeadstock(){
            this.$store.dispatch("generic/setLoading", true);

            for(let i = 0; i < this.deadstocks.length; i++){
                if(this.deadstocks[i] != null){
                    this.deadstocks[i].referenceDate = new Date();
                }
            }

            Service.insertMassiveDeadstocks(this.deadstocks, (response) => {
                this.$store.dispatch("generic/setLoading", false);
                if (response.success) {
                    this.showDeadstockDialog = false;
                    this.deadstocks = [];
                    this.loadStockAdjustment();
                    this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.create_message_success'), life: 3000 });
                } else {
                    this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
            })
        },
        _formatDate24Hour(date){
            let formatDate = new Date(date);
            formatDate.setDate(formatDate.getDate() - 1);

            const day = String(formatDate.getDate()).padStart(2, '0');
            const month = String(formatDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
            const year = formatDate.getFullYear();

            return `${day}/${month}/${year}` + ' 24:00';
        }
    }
}
</script>

<template>
    <main>
        <Dialog v-model:visible="showAddDialog" :style="{width: '85vw'}" modal>
            <div class="grid" style="padding: 2%;" v-for="item in addItem" :key="item.name">             
                <div class="col-12 lg:col-3" v-for="field in getFields()" :key="field.name">
                    <label :for="field.name">{{$t(field.label)}}</label>
                    <InputText                         
                        v-if="field.type == 'string' && !field.formHide" 
                        :class="{'p-invalid':setClass(field.name), 'w-full': true}"
                        v-model="item[field.name]" />
                    <InputText                       
                        class="w-full" 
                        type="number" 
                        v-if="field.type == 'number'"
                        v-model="item[field.name]" />
                    <InputNumber                        
                        :class="{'p-invalid':setClass(field.name), 'w-full': true}" 
                        mode="decimal" :maxFractionDigits="field.digits"
                        v-if="field.type == 'decimal'"
                        v-model="item[field.name]" />
                    <!--<GenericDateTimeMaskV2 
                        v-if="field.type == 'date'"    
                        v-model="editItem[field.name]"
                        mask="99/99/9999 99:99:99"
                        :unmask="true" />-->
                    <Calendar 
                        :class="{'p-invalid':setClass(field.name), 'w-full': true}" 
                        v-if="field.type == 'date'"    
                        :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                        :dateFormat="constants.DATE_FORMAT_POINT"
                        :showTime="field.onlyDate ? false : true"
                        v-model="item[field.name]" />   
                    <GenericCustomAutocompleteV2
                        :class="{'p-invalid':setClass(field.name), 'w-full': true}"                     
                        v-if="field.type == 'select'"
                        :name="field.name"
                        v-model="item[field.updateField ?? field.name]" 
                        :api="field.selectApi"                  
                        :format="field.selectFormat" />               
                </div> 
            </div>

            <div style="padding-left: 2%;" class="col-12 lg:col-4">
                <ResponsiveButton :label="$t('btn.calculate')" class="p-button-success my-2" icon="pi pi-percentage" @click="calculate()" autofocus v-if="checkAdjustment() && !this.disableCalculate"/>
                <ul id="validation">
                    <li style="color: red; list-style: none;" v-for="field in this.validationMessage" :key="field">
                        {{$t('StockAdjustment.field') + ' ' + $t('StockAdjustment.'+ field) + ' ' + $t('StockAdjustment.required')}}
                    </li>
                </ul>
            </div>

            <template #footer>
                <ResponsiveButton :label="$t('btn.reset')" class="p-button-outlined" icon="pi pi-trash" @click="resetForm()" autofocus />
                <ResponsiveButton :label="$t('btn.save')" icon="pi pi-save" @click="dialogAddSave" autofocus />               
            </template>
        </Dialog>

        <Dialog v-model:visible="showDeadstockDialog" header="Import Deadstock" :style="{width: '60vw'}" modal>
            <div class="grid" style="padding: 2%;">             
                <div class="col-12 lg:col-3">
                    <label style="font-weight: bold;">{{$t("StockAdjustment.initialStockDate")}}</label>
                    <Calendar  
                        class="w-full" 
                        :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                        :dateFormat="constants.DATE_FORMAT_POINT"
                        :showTime="false"
                        v-model="deadstockFilter.initialStockDate" />     
                </div> 

                <div class="col-12 lg:col-3">
                    <label style="font-weight: bold;">{{$t("StockAdjustment.date")}}</label>
                    <Calendar   
                        class="w-full"
                        :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                        :dateFormat="constants.DATE_FORMAT_POINT"
                        :showTime="false"
                        v-model="deadstockFilter.finalStockDate" />     
                </div> 

                <div class="col-12 lg:col-3 my-4">                  
                    <ResponsiveButton :label="$t('btn.calculate')" class="p-button-success p-button-sm" icon="pi pi-upload" @click="massiveImportDeadstock()" autofocus />    
                </div>
            </div>

            <div class="grid" style="padding: 2%;" v-for="item in deadstocks" :key="item.name">  
                <Card class="w-full" style="background-color: #f2f2f2;">
                    <template #content>
                        <div class="grid">                                                 
                            <div class="col-12 lg:col-3" v-for="field in getFields()" :key="field.name">
                                <label style="font-weight: bold;" :for="field.name">{{$t(field.label)}}</label>
                                <InputText                         
                                    v-if="field.type == 'string' && !field.formHide && field.name != 'description'" 
                                    :class="{'p-invalid':setClass(field.name), 'w-full': true}"
                                    v-model="item[field.name]" 
                                    :disabled="field.name == 'referenceDate'" />
                                <Textarea                         
                                    v-if="field.type == 'string' && !field.formHide && field.name == 'description'" 
                                    :class="{'p-invalid':setClass(field.name), 'w-full': true}"
                                    v-model="item[field.name]" />
                                <InputText                       
                                    class="w-full" 
                                    type="number" 
                                    v-if="field.type == 'number'"
                                    v-model="item[field.name]" />
                                <InputNumber                        
                                    :class="{'p-invalid':setClass(field.name), 'w-full': true}" 
                                    mode="decimal" :maxFractionDigits="field.digits"
                                    v-if="field.type == 'decimal'"
                                    v-model="item[field.name]" />
                                <!--<GenericDateTimeMaskV2 
                                    v-if="field.type == 'date'"    
                                    v-model="editItem[field.name]"
                                    mask="99/99/9999 99:99:99"
                                    :unmask="true" />-->
                                <Calendar 
                                    :class="{'p-invalid':setClass(field.name), 'w-full': true}" 
                                    v-if="field.type == 'date'"    
                                    :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                                    :dateFormat="constants.DATE_FORMAT_POINT"
                                    :showTime="field.onlyDate ? false : true"
                                    v-model="item[field.name]" 
                                    :disabled="field.name == 'referenceDate'" />   
                                <GenericCustomAutocompleteV2
                                    :class="{'p-invalid':setClass(field.name), 'w-full': true}"                     
                                    v-if="field.type == 'select'"
                                    :name="field.name"
                                    v-model="item[field.updateField ?? field.name]" 
                                    :api="field.selectApi"                  
                                    :format="field.selectFormat" />               
                            </div> 
                        </div>
                    </template>
                </Card>
            </div>

            <template #footer v-if="this.deadstocks.length > 0">
                <ResponsiveButton :label="$t('btn.reset')" class="p-button-outlined" icon="pi pi-trash" @click="resetFormDeadstock()" autofocus /> 
                <ResponsiveButton :label="$t('btn.save')" class="p-button" icon="pi pi-save" @click="saveMassiveDeadstock()" autofocus />                                                     
            </template>
        </Dialog>

        <div class="grid">
            <div class="col-2">
                <label for="dateFrom">{{$t('StockAdjustment.monthStartDate')}}</label>
                <Calendar
                class="p-inputtext-sm w-full"
                placeholder="__/__/____"
                v-model="this.filters.monthStartDate"
                name="monthStartDate" dateFormat="mm/yy" :showTime="false"
                :showIcon="true" :showButtonBar="true" :yearNavigator="true" 
                view="month" />
            </div>

            <div class="col-12 lg:col-4 m-3">
                <ResponsiveButton :label="$t('btn.load')" icon="pi pi-replay" class="m-1 p-button-sm p-button" @click="loadStockAdjustment()"/>
                <ResponsiveButton :label="$t('btn.add')" icon="pi pi-plus" class="m-1 p-button-sm p-button-success" @click="showAddDialog = true"/>
                <ResponsiveButton :label="$t('StockAdjustment.importDeadstock')" icon="pi pi-plus" class="m-1 p-button-sm p-button" @click="showDeadstockDialog = true"/>
                <ResponsiveButton :label="$t('StockAdjustment.sendToLotManagement')" icon="pi pi-upload" class="m-1 p-button-sm outlined p-button-success" 
                @click="importAdjustment()" :disabled="selectedItems.length == 0" v-if="!uiPermissions('importAdjustmentToLotManagementButton').isHidden" />
            </div>
            
            <div class="col-12">
                <GenericDataTable :configuration="configuration" :category="'planning'" :name="'true-up-stock-adjustment'" 
                ref="stockAdjustment" :onDialogEditSave="onRowEdit" :onRowSelectedChangeFn="onRowSelected" />
            </div>
        </div>
    </main>
</template>

<style>

    .p-invalid{
        border-color: red;
    }

</style>